import * as React from 'react';
import {AccountContainer} from '../../components/accounts/AccountContainer';

function AccountForm(props) : JSX.Element{
  return <AccountContainer {...props} />;
}

export default AccountForm;